"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EstimateComponent = void 0;
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var styles = __importStar(require("./Common.module.css"));
var StudentInformation_1 = require("./parts/StudentInformation");
var classnames_1 = __importDefault(require("classnames"));
var components_1 = require("components");
function EstimateComponent(props) {
    var model = (0, react_redux_1.useSelector)(function (_a) {
        var model = _a.model;
        return model;
    });
    var _a = (0, react_1.useState)(false), isVisible = _a[0], setIsVisible = _a[1];
    var isPdf = false;
    if (window.isPdf) {
        isPdf = true;
    }
    var onClickLogin = function () {
        setIsVisible(true);
    };
    var onClickLogout = function () {
        model.logout();
    };
    var onClose = function () {
        setIsVisible(false);
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.containerPosition, styles.pageBreak) },
        !isPdf && react_1.default.createElement("div", { className: (0, classnames_1.default)("gray-line", styles.displayNone) }),
        isVisible && react_1.default.createElement(components_1.Popup, { model: model, onClose: onClose }),
        react_1.default.createElement("div", { className: (0, classnames_1.default)(styles.pageSize, styles.pageBreak) },
            react_1.default.createElement(StudentInformation_1.StudentInformationComponent, { onClickLogin: onClickLogin, onClickLogout: onClickLogout, onClose: onClose, isPdf: isPdf })),
        !isPdf && react_1.default.createElement("div", { className: (0, classnames_1.default)("gray-line", styles.displayNone) })));
}
exports.EstimateComponent = EstimateComponent;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXN0aW1hdGUuY29tcG9uZW50LmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvZm9ybXMvYXZlZGFtYWluZS9Fc3RpbWF0ZVN0YW5kYWxvbmUvRXN0aW1hdGUuY29tcG9uZW50LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBLDZDQUFnRDtBQUNoRCwyQ0FBb0Q7QUFDcEQsMERBQTZDO0FBQzdDLGlFQUFzRTtBQUV0RSwwREFBMkI7QUFDM0IseUNBQWdDO0FBRWhDLFNBQWdCLGlCQUFpQixDQUFDLEtBQUs7SUFDbkMsSUFBTSxLQUFLLEdBQUcsSUFBQSx5QkFBVyxFQUFDLFVBQUMsRUFBWTtZQUFYLEtBQUssV0FBQTtRQUFXLE9BQUEsS0FBSztJQUFMLENBQUssQ0FBQyxDQUFBO0lBQzVDLElBQUEsS0FBNEIsSUFBQSxnQkFBUSxFQUFVLEtBQUssQ0FBQyxFQUFuRCxTQUFTLFFBQUEsRUFBRSxZQUFZLFFBQTRCLENBQUE7SUFFMUQsSUFBSSxLQUFLLEdBQUcsS0FBSyxDQUFBO0lBQ2pCLElBQUksTUFBTSxDQUFDLEtBQUssRUFBRTtRQUNkLEtBQUssR0FBRyxJQUFJLENBQUE7S0FDZjtJQUVELElBQU0sWUFBWSxHQUFHO1FBQ2pCLFlBQVksQ0FBQyxJQUFJLENBQUMsQ0FBQTtJQUN0QixDQUFDLENBQUE7SUFFRCxJQUFNLGFBQWEsR0FBRztRQUNsQixLQUFLLENBQUMsTUFBTSxFQUFFLENBQUE7SUFDbEIsQ0FBQyxDQUFBO0lBRUQsSUFBTSxPQUFPLEdBQUc7UUFDWixZQUFZLENBQUMsS0FBSyxDQUFDLENBQUE7SUFDdkIsQ0FBQyxDQUFBO0lBRUQsT0FBTyxDQUNILHVDQUFLLFNBQVMsRUFBRSxJQUFBLG9CQUFFLEVBQUMsTUFBTSxDQUFDLGlCQUFpQixFQUFFLE1BQU0sQ0FBQyxTQUFTLENBQUM7UUFDekQsQ0FBQyxLQUFLLElBQUksdUNBQUssU0FBUyxFQUFFLElBQUEsb0JBQUUsRUFBQyxXQUFXLEVBQUUsTUFBTSxDQUFDLFdBQVcsQ0FBQyxHQUFRO1FBQ3JFLFNBQVMsSUFBSSw4QkFBQyxrQkFBSyxJQUFDLEtBQUssRUFBRSxLQUFLLEVBQUUsT0FBTyxFQUFFLE9BQU8sR0FBSTtRQUN2RCx1Q0FBSyxTQUFTLEVBQUUsSUFBQSxvQkFBRSxFQUFDLE1BQU0sQ0FBQyxRQUFRLEVBQUUsTUFBTSxDQUFDLFNBQVMsQ0FBQztZQUNqRCw4QkFBQyxnREFBMkIsSUFDeEIsWUFBWSxFQUFFLFlBQVksRUFDMUIsYUFBYSxFQUFFLGFBQWEsRUFDNUIsT0FBTyxFQUFFLE9BQU8sRUFDaEIsS0FBSyxFQUFFLEtBQUssR0FDZCxDQUNBO1FBQ0wsQ0FBQyxLQUFLLElBQUksdUNBQUssU0FBUyxFQUFFLElBQUEsb0JBQUUsRUFBQyxXQUFXLEVBQUUsTUFBTSxDQUFDLFdBQVcsQ0FBQyxHQUFRLENBQ3BFLENBQ1QsQ0FBQTtBQUNMLENBQUM7QUFwQ0QsOENBb0NDIn0=